// API 基础地址，直连
export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'http://localhost:8001'
